import { API, ApiResult } from "./API";

export class WS {

  static WS_PATH = "/api/ws/";


  /**
   * 其實就是呼叫 API.Call_POST，只是先集中在這裡，方便之後批次修改
   */
  static async CallWS(endpoint: string, body: any | undefined): Promise<ApiResult> {
    const rslt = API.Call_POST(WS.WS_PATH + endpoint, body);
    return rslt;
  }

}

export class AUTH {

  static AUTH_PATH = "/api/auth/";


  /**
   * 其實就是呼叫 API.Call_POST，只是先集中在這裡，方便之後批次修改
   */
  static async CallAUTH(endpoint: string, body: any | undefined): Promise<ApiResult> {
    const rslt = API.Call_POST(AUTH.AUTH_PATH + endpoint, body);
    return rslt;
  }

}
export class WS_Public {

  static Public_PATH = "/api/public/";

  static async CallPublicGet(endpoint: string, body: any | undefined): Promise<ApiResult> {
    const rslt = API.Call_GET(WS_Public.Public_PATH + endpoint, body);
    return rslt;
  }
  static async CallPublicPost(endpoint: string, body: any | undefined): Promise<ApiResult> {
    const rslt = API.Call_POST(WS_Public.Public_PATH + endpoint, body);
    return rslt;
  }

}
export class WS_Sys {

  static Public_PATH = "/api/sys/";

  static async CallPublicGet(endpoint: string, body: any | undefined): Promise<ApiResult> {
    const rslt = API.Call_GET(WS_Sys.Public_PATH + endpoint, body);
    return rslt;
  }
  static async CallPublicPost(endpoint: string, body: any | undefined): Promise<ApiResult> {
    const rslt = API.Call_POST(WS_Sys.Public_PATH + endpoint, body);
    return rslt;
  }

}


